/* ==========================================================================
   TD COLLECTION  —  assets/td-collection.js

   The cards are rendered by Liquid, not by this file. That matters: they are
   in the HTML Google receives, they work with JavaScript off, and the section
   stays the source of truth for pricing. This script reads what Liquid wrote
   off each card's data- attributes and drives the filtering on top.

   Why size is a query and not six checkboxes:
     · Ticking Width 225 leaves 21 different sizes, only one of which fits the
       car outside. Width and Profile are two thirds of one value.
     · The median size in this catalogue holds ONE tyre, so once the size is
       known there is usually nothing left to narrow — the refine block folds
       itself and says so.
   ========================================================================== */
(function () {
  "use strict";

  var SIZE = ["width", "prof", "rim"];

  var FACETS = [
    { key: "band",  label: "Price" },
    { key: "brand", label: "Brand" },
    { key: "patt",  label: "Pattern" },
    { key: "types", label: "Tyre type" },
    { key: "ply",   label: "Build" },
    { key: "pdir",  label: "Tread direction" }
  ];

  /* Bands rather than a slider: a slider cannot tell you how many are in
     reach before you drag it, and it is a fiddle on a phone. */
  var BANDS = [
    { id: "u120", label: "Under $120",  hi: 120 },
    { id: "120",  label: "$120 – $169", hi: 170 },
    { id: "170",  label: "$170 – $229", hi: 230 },
    { id: "230",  label: "$230 – $319", hi: 320 },
    { id: "320",  label: "$320 +",      hi: 1e9 }
  ];
  var BANDLABEL = {};
  BANDS.forEach(function (b) { BANDLABEL[b.id] = b.label; });

  var CAP = 8;              // options before "+ n more"
  var NO_POINT_BELOW = 9;   // below this many results, refining is theatre
  var NARROW = "(max-width: 720px)";   // same breakpoint the stylesheet uses

  function has(p, k, v) {
    var val = p[k];
    return Array.isArray(val) ? val.indexOf(v) > -1 : (val || "") === v;
  }
  function each(p, k, fn) {
    var val = p[k];
    if (Array.isArray(val)) val.forEach(fn);
    else if (val) fn(val);
  }
  function bandOf(price) {
    for (var i = 0; i < BANDS.length; i++) if (price < BANDS[i].hi) return BANDS[i].id;
    return BANDS[BANDS.length - 1].id;
  }

  function TDCollection(root) {
    var self = this;
    this.root   = root;
    this.grid   = root.querySelector("[data-grid]");
    this.slot   = root.querySelector("[data-facet-ui]");
    this.sizer  = root.querySelector("[data-sizer]");
    this.counts = [].slice.call(root.querySelectorAll("[data-count]"));
    this.empty  = root.querySelector("[data-empty]");
    this.clear  = root.querySelector("[data-clear]");
    this.active = root.querySelector("[data-active]");
    this.refine = root.querySelector("[data-refine]");
    this.quick  = root.querySelector("[data-quick]");
    this.lay    = root.querySelector("[data-layout]");
    this.more   = root.querySelector("[data-more-btn]");
    if (!this.grid || !this.slot) return;

    this.size = { width: "", prof: "", rim: "" };
    this.state = {};
    FACETS.forEach(function (f) { self.state[f.key] = []; });
    this.stock = false;
    this.sort = "feat";
    this.shownCap = parseInt(root.getAttribute("data-page-size"), 10) || 24;
    /* What the whole collection holds, against what this page was given. 250
       is Shopify's ceiling for one page, so /all-tyres arrives as 250 of 329
       and the count has to say so rather than calling 250 the total. */
    this.allItems = parseInt(root.getAttribute("data-all"), 10) || 0;
    this.pages = parseInt(root.getAttribute("data-pages"), 10) || 1;
    this.page = parseInt(root.getAttribute("data-page"), 10) || 1;

    this.readCards();
    this.seedSize();
    this.bind();
    this.renderFacets();
    this.renderQuick();
    this.apply();
    this.loadRest();
  }

  /* ---- the products, straight off what Liquid rendered ------------------- */
  /* A size collection has already been chosen, so the rail says so. Three
     empty boxes over a page of one size was asking the customer a question
     they had already answered, and the only answer the boxes would take was
     the one already on screen.

     Only where the handle really is a size. all-terrain-tyres, anchee and the
     rest leave it blank, because there is nothing true to put in it. */
  TDCollection.prototype.seedSize = function () {
    var h = (this.root.getAttribute("data-collection") || "").toLowerCase();
    var m = /(?:^|[^0-9])(\d{2,3})-(\d{2,3})(?:zrf|zr|r)(\d{2})(?:[^0-9]|$)/.exec(h);
    var want;
    if (m) {
      want = { width: m[1], prof: m[2], rim: m[3] };
    } else {
      /* r21, r-16, r-20: the rim on its own is still something the customer
         has already said, so the third step says it and the first two stay
         open for them to narrow with. */
      var r = /^r-?(\d{2})$/.exec(h);
      if (!r) return;
      want = { width: "", prof: "", rim: r[1] };
    }
    var self = this, hit = false;
    ["width", "prof", "rim"].forEach(function (k) {
      if (!want[k]) return;
      var any = self.data.some(function (p) { return p[k] === want[k]; });
      if (any) { self.size[k] = want[k]; hit = true; }
    });
    /* remembered, so the "Filtering by" chip does not offer to clear
       something the customer never set */
    if (hit) this.seeded = want.width + "/" + want.prof + "R" + want.rim;
  };

  TDCollection.prototype.readCards = function () {
    this.cards = [].slice.call(this.grid.querySelectorAll("[data-tyre]"));
    this.data = this.cards.map(function (c, i) {
      c.dataset.i = i;
      var d = c.dataset;
      var price = parseFloat(d.only) || 0;
      return {
        width: d.width || "", prof: d.prof || "", rim: d.rim || "",
        brand: d.brand || "", patt: d.patt || "", ply: d.ply || "",
        pdir:  d.pdir  || "", size: d.size || "",
        types: (d.types || "").split("|").filter(Boolean),
        only: price, band: bandOf(price),
        avail: d.avail === "1",
        oi: d.oi === "1"
      };
    });
  };

  TDCollection.prototype.bind = function () {
    var self = this;

    this.slot.addEventListener("change", function () { self.apply(); });
    this.slot.addEventListener("click", function (e) {
      var m = e.target.closest("[data-more]");
      if (m) { m.parentNode.classList.add("is-open"); m.remove(); return; }
      var h = e.target.closest(".td-fgroup__h");
      if (h) h.parentNode.classList.toggle("is-shut");
    });

    if (this.clear) this.clear.addEventListener("click", function () { self.reset(); });

    if (this.active) this.active.addEventListener("click", function (e) {
      var c = e.target.closest("[data-drop]"); if (!c) return;
      var k = c.dataset.drop;
      if (k === "stock") { var s = self.slot.querySelector("input[data-stock]"); if (s) s.checked = false; }
      else if (k === "size") self.size = { width: "", prof: "", rim: "" };
      else {
        var b = self.slot.querySelector('input[data-k="' + k + '"][value="' + c.dataset.v + '"]');
        if (b) b.checked = false;
      }
      self.apply();
    });

    if (this.sizer) {
      this.sizer.addEventListener("change", function (e) {
        var s = e.target.closest("[data-sz]"); if (!s) return;
        self.size[s.dataset.sz] = s.value;
        self.apply();
      });
      var rs = this.sizer.querySelector("[data-sz-reset]");
      if (rs) rs.addEventListener("click", function () { self.reset(); });
    }

    if (this.quick) this.quick.addEventListener("click", function (e) {
      var q = e.target.closest("[data-size]"); if (!q) return;
      var b = q.dataset.size.match(/^(\d+(?:\.\d+)?)\/(\d+(?:\.\d+)?)R(\d+)$/);
      if (!b) return;
      self.size = { width: b[1], prof: b[2], rim: b[3] };
      self.apply();
    });

    var sortSel = this.root.querySelector("[data-sort]");
    if (sortSel) sortSel.addEventListener("change", function () {
      self.sort = sortSel.value; self.applySort(); self.paint();
    });

    if (this.refine) {
      var head = this.refine.querySelector("[data-refine-h]");
      if (head) head.addEventListener("click", function () { self.refine.classList.toggle("is-shut"); });
    }

    if (this.more) this.more.addEventListener("click", function () {
      self.shownCap = 1e9; self.paint();
    });

    /* Layout is the visitor's call and it sticks. localStorage is wrapped
       because a private window throws on read rather than returning null. */
    var sw = this.root.querySelector("[data-layswitch]");
    if (this.lay && sw) {
      var KEY = "td-coll-layout", saved = null;
      try { saved = localStorage.getItem(KEY); } catch (e) {}
      this.setLayout(saved === "wide" ? "wide" : "rail");
      sw.addEventListener("click", function (e) {
        var b = e.target.closest("button[data-lay]"); if (!b) return;
        self.setLayout(b.dataset.lay);
        try { localStorage.setItem(KEY, b.dataset.lay); } catch (e2) {}
      });
    }
  };

  TDCollection.prototype.setLayout = function (mode) {
    if (!this.lay) return;
    this.lay.dataset.layout = mode;
    [].forEach.call(this.root.querySelectorAll("[data-layswitch] button"), function (b) {
      var on = b.dataset.lay === mode;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    /* Wide puts the facets behind a drawer; below 720 there is no rail at all,
       so they fold either way. Only ever CLOSE here — a plain toggle would
       fight the visitor every time the result count changed. */
    var narrow = window.matchMedia && window.matchMedia(NARROW).matches;
    if (this.refine && !this.refine.classList.contains("is-moot")) {
      this.refine.classList.toggle("is-shut", mode === "wide" || narrow);
    }
  };

  TDCollection.prototype.reset = function () {
    this.size = { width: "", prof: "", rim: "" };
    [].forEach.call(this.slot.querySelectorAll("input"), function (i) { i.checked = false; });
    this.apply();
  };

  TDCollection.prototype.values = function (key) {
    var n = {}, out = [];
    this.data.forEach(function (p) {
      each(p, key, function (v) { if (!n[v]) { n[v] = 0; out.push(v); } n[v]++; });
    });
    if (key === "band") return BANDS.map(function (b) { return b.id; })
                                    .filter(function (id) { return n[id]; });
    if (SIZE.indexOf(key) > -1) {
      /* Width is three kinds of number in one list, and sorting them together
         put 7.00 and 31 above 155. They are not small widths -- they are a
         different way of writing a tyre.

           metric    155 to 315, the millimetre width
           imperial  31 to 35, the overall diameter in inches on a flotation
                     size like 31x10.50R15
           legacy    7.00, 7.50, the old truck sizes

         Metric first, because nearly everything we sell is metric. Then the
         imperial ones, then the legacy ones, each in order inside its group.
         Profile and rim are one kind of number, so they stay as they were. */
      if (key === "width") {
        var kind = function (v) {
          var f = parseFloat(v);
          if (f >= 100) return 0;                       /* 155, 205, 315 */
          if (String(v).indexOf(".") > -1) return 2;    /* 7.00, 7.50 */
          return 1;                                     /* 31, 33, 35 */
        };
        out.sort(function (a, b) {
          return kind(a) - kind(b) || parseFloat(a) - parseFloat(b);
        });
        return out;
      }
      out.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      return out;
    }
    /* biggest first: alphabetical buried the brands people actually buy */
    out.sort(function (a, b) { return n[b] - n[a] || (a < b ? -1 : 1); });
    return out;
  };

  TDCollection.prototype.hit = function (p, ignore) {
    for (var k in this.size) {
      if (ignore === "size:" + k) continue;
      if (this.size[k] && p[k] !== this.size[k]) return false;
    }
    for (var f in this.state) {
      if (f === ignore) continue;
      var sel = this.state[f];
      if (sel.length) {
        var any = false;
        for (var s = 0; s < sel.length; s++) if (has(p, f, sel[s])) { any = true; break; }
        if (!any) return false;
      }
    }
    if (ignore !== "stock" && this.stock && (!p.avail || p.oi)) return false;
    return true;
  };

  TDCollection.prototype.renderFacets = function () {
    var self = this, html = "";
    FACETS.forEach(function (f) {
      var vals = self.values(f.key);
      if (!vals.length) return;
      var label = function (v) { return f.key === "band" ? BANDLABEL[v] : v; };

      /* Brands split in two: the ones we hold, and the ones every tyre of
         which we would order in. A brand with even one on the shelf counts as
         held. Worked out from the products on the page rather than a list, so
         a supplier brand appears here the day its first listing does, and
         never appears as a tick that finds nothing. */
      var order = vals, split = -1;
      if (f.key === "brand") {
        var held = [], supplied = [];
        vals.forEach(function (v) {
          var all = true;
          self.data.forEach(function (p) {
            if (p.brand === v && !p.oi) all = false;
          });
          (all ? supplied : held).push(v);
        });
        if (supplied.length) { order = held.concat(supplied); split = held.length; }
      }
      var vals = order;

      html += '<div class="td-fgroup" data-k="' + f.key + '">'
            + '<button class="td-fgroup__h" type="button"><span>' + f.label + '</span>'
            + '<i data-badge></i></button><div class="td-fgroup__b"><div class="td-fopts">'
            + vals.map(function (v, i) {
                var head = (i === split)
                  ? '<p class="td-fsub">' + (self.oiBrandLabel
                      || "Other brands we can order in") + '</p>' : "";
                return head + 
                       '<label class="td-fopt' + (i >= CAP && split < 0 ? " is-extra" : "") + '">'
                     + '<input type="checkbox" data-k="' + f.key + '" value="'
                     + String(v).replace(/"/g, "&quot;") + '">'
                     + '<span>' + label(v) + '</span><b data-c></b></label>';
              }).join("")
            + (vals.length > CAP
                ? '<button class="td-fmore" type="button" data-more>+ '
                  + (vals.length - CAP) + ' more</button>' : "")
            + (vals.length === 1
                ? '<p class="td-fnote">Everything here is '
                  + String(label(vals[0])).toLowerCase() + '</p>' : "")
            + '</div></div></div>';
    });
    html += '<div class="td-fgroup" data-k="stock"><button class="td-fgroup__h" type="button">'
          + '<span>Availability</span><i data-badge></i></button><div class="td-fgroup__b">'
          + '<div class="td-fopts"><label class="td-fopt"><input type="checkbox" data-stock>'
          + '<span>In stock now</span><b data-c></b></label></div></div></div>';
    this.slot.innerHTML = html;
  };

  TDCollection.prototype.renderQuick = function () {
    if (!this.quick) return;
    var c = {};
    this.data.forEach(function (p) { if (p.size) c[p.size] = (c[p.size] || 0) + 1; });
    var top = Object.keys(c).sort(function (a, b) { return c[b] - c[a]; }).slice(0, 6);
    this.quick.innerHTML = top.length
      ? '<span class="td-quick__lbl">Most asked for</span>' + top.map(function (s) {
          return '<button class="td-quick" type="button" data-size="' + s + '">'
               + s + '<i>' + c[s] + '</i></button>'; }).join("")
      : "";
  };

  TDCollection.prototype.read = function () {
    var self = this;
    FACETS.forEach(function (f) { self.state[f.key] = []; });
    [].forEach.call(this.slot.querySelectorAll("input[data-k]"), function (i) {
      if (i.checked) self.state[i.dataset.k].push(i.value);
    });
    var s = this.slot.querySelector("input[data-stock]");
    this.stock = !!(s && s.checked);
  };

  TDCollection.prototype.apply = function () {
    var self = this;
    this.read();

    this.matched = [];
    this.cards.forEach(function (c) {
      if (self.hit(self.data[c.dataset.i | 0], null)) self.matched.push(c);
    });

    [].forEach.call(this.slot.querySelectorAll("input[data-k]"), function (i) {
      var k = i.dataset.k, v = i.value, n = 0;
      self.data.forEach(function (p) { if (has(p, k, v) && self.hit(p, k)) n++; });
      var b = i.parentNode.querySelector("[data-c]");
      if (b) b.textContent = n;
      i.parentNode.classList.toggle("is-off", n === 0 && !i.checked);
      i.disabled = n === 0 && !i.checked;
    });
    var sb = this.slot.querySelector("input[data-stock]");
    if (sb) {
      var n = 0;
      this.data.forEach(function (p) {
        if (p.avail && !p.oi && self.hit(p, "stock")) n++;
      });
      sb.parentNode.querySelector("[data-c]").textContent = n;
    }

    var ticks = 0;
    [].forEach.call(this.slot.querySelectorAll(".td-fgroup"), function (g) {
      var t = g.querySelectorAll("input:checked").length;
      ticks += t;
      var tag = g.querySelector("[data-badge]");
      if (tag) tag.textContent = t ? t : "";
      g.classList.toggle("is-on", t > 0);
    });
    this.ticks = ticks;

    if (this.refine) {
      var pointless = this.matched.length > 0 && this.matched.length < NO_POINT_BELOW && ticks === 0;
      if (pointless) { this.refine.classList.add("is-shut"); this.autoShut = true; }
      else if (this.autoShut) { this.refine.classList.remove("is-shut"); this.autoShut = false; }
      this.refine.classList.toggle("is-moot", pointless);
      var note = this.refine.querySelector("[data-refine-note]");
      if (note) note.textContent = pointless ? "all " + this.matched.length + " shown" : "";
    }

    if (this.sizer) this.syncSizer();
    this.renderActive();
    this.applySort();
    this.paint();
  };

  /* ------------------------------------------------------------ the rest
     250 is Shopify's ceiling for one Liquid page, and only /all-tyres is over
     it. Rather than leave the filters counting 250 of 329 -- a filter that
     lies by a quarter -- the remaining pages are fetched once the first has
     drawn, and their cards are lifted straight out of the returned HTML.

     Out of the HTML, not out of the JSON view, because that way the cards are
     the ones this same section rendered. Building them a second time in
     JavaScript would be two card designs to keep in step, and they would
     drift the first time one of them changed.

     It costs one request on one collection, after the page is already usable.
     If it fails, the page keeps the 250 it has and keeps saying so. */
  TDCollection.prototype.loadRest = function () {
    var self = this;
    if (!(this.pages > 1) || !window.fetch || !window.DOMParser) return;

    var note = document.createElement("p");
    note.className = "td-pager__more";
    note.textContent = "Loading the other "
      + (this.allItems - this.cards.length) + "…";
    var wrap = this.root.querySelector(".td-pager__wrap");
    if (wrap) wrap.insertBefore(note, wrap.firstChild);

    /* Every page except the one already here. Starting at 2 meant that
       landing on page 2 -- which the links at the foot make easy -- fetched
       page 2 again, added nothing, and left the count reading 79 of 329 with
       page one's 250 nowhere. */
    var base = location.pathname, jobs = [];
    var want = [];
    for (var p = 1; p <= this.pages; p++) {
      if (p === this.page) continue;
      want.push(p);
      jobs.push(fetch(base + "?page=" + p, { headers: { Accept: "text/html" } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }));
    }
    /* Every tyre already on the page, by address. A server that ignores
       ?page -- or a redirect back to page one -- would otherwise hand back
       the same 250 and the grid would double. Caught in testing, where a
       static file server did exactly that and 250 became 500. */
    var have = {}, self2 = this;
    this.cards.forEach(function (c) {
      have[c.getAttribute("href")] = 1;
      c.dataset.pg = self2.page;
    });

    Promise.all(jobs).then(function (pages) {
      var frag = document.createDocumentFragment(), added = 0;
      pages.forEach(function (html, idx) {
        var pg = want[idx];
        var doc = new DOMParser().parseFromString(html, "text/html");
        [].forEach.call(doc.querySelectorAll("[data-grid] [data-tyre]"), function (c) {
          var href = c.getAttribute("href");
          if (have[href]) return;
          have[href] = 1;
          c.dataset.pg = pg;
          frag.appendChild(document.adoptNode(c));
          added++;
        });
      });
      if (!added) { note.remove(); return; }
      self.grid.appendChild(frag);
      self.readCards();          /* data-i is renumbered over the whole lot */
      self.renderFacets();
      self.renderQuick();
      self.apply();
      note.remove();
      /* Page one first, whichever page was landed on. The cards came back in
         page order but were appended after whatever was already here, so on
         page 2 the last 79 would have led the first 250. */
      var order = self.cards.slice().sort(function (a, b) {
        return (a.dataset.pg | 0) - (b.dataset.pg | 0);
      });
      var f2 = document.createDocumentFragment();
      order.forEach(function (c) { f2.appendChild(c); });
      self.grid.appendChild(f2);
      self.readCards();
      self.apply();
      /* the page links are for somebody without JavaScript; everything they
         point at is on this page now */
      /* Shopify's default_pagination is a bare run of links with no wrapper
         of its own, so the section puts one round it and this hides that.
         Guessing at .pagination missed it and the links stayed on a page that
         already held everything they pointed at. */
      var links = self.root.querySelector("[data-pager-links]");
      if (links) links.hidden = true;
      var over = self.root.querySelector(".td-pager__more");
      if (over) over.remove();
    }).catch(function () {
      note.textContent = "Could not load the rest. "
        + "Showing the first " + self.cards.length + ".";
    });
  };

  /* one place that decides what is on screen */
  TDCollection.prototype.paint = function () {
    var self = this, shown = 0;
    this.cards.forEach(function (c) { c.hidden = true; });
    this.matched.forEach(function (c, i) {
      if (i < self.shownCap) { c.hidden = false; shown++; }
    });
    var total = this.matched.length;
    var label = "<b>" + total + "</b> " + (total === 1 ? "tyre" : "tyres");
    /* only when there is a second page, and only when nothing is filtered --
       "3 of 329" would be nonsense once a filter is on */
    if (this.pages > 1 && this.allItems > total && !this.ticks
        && !(this.size.width || this.size.prof || this.size.rim) && !this.stock) {
      label = "<b>" + total + "</b> of " + this.allItems + " tyres";
    }
    this.counts.forEach(function (n) { n.innerHTML = label; });
    if (this.empty) this.empty.hidden = total > 0;
    if (this.clear) this.clear.hidden = this.ticks === 0
      && !(this.size.width || this.size.prof || this.size.rim);
    if (this.more) {
      var left = total - shown;
      this.more.hidden = left <= 0;
      this.more.textContent = "Show all " + total + " tyres";
    }
    var note = this.root.querySelector("[data-showing]");
    if (note) note.textContent = total ? "Showing " + shown + " of " + total : "";
    this.placeBand();
  };

  /* The band goes in front of the first ordered-in card that is actually on
     screen, which changes every time a filter or the pager does. It is moved
     rather than redrawn so nothing flickers. */
  TDCollection.prototype.placeBand = function () {
    var band = this.grid.querySelector("[data-oiband]");
    if (!band) return;
    var self = this, first = null;
    this.matched.some(function (c) {
      if (!c.hidden && self.data[c.dataset.i | 0].oi) { first = c; return true; }
      return false;
    });
    if (!first) { band.hidden = true; return; }
    band.hidden = false;
    if (first.previousElementSibling !== band) {
      this.grid.insertBefore(band, first);
    }
  };

  TDCollection.prototype.renderActive = function () {
    if (!this.active) return;
    var self = this, chips = [];
    var w = this.size.width, p = this.size.prof, r = this.size.rim;
    var sig = (w || "") + "/" + (p || "") + "R" + (r || "");
    if ((w || p || r) && sig !== this.seeded)
      chips.push('<button class="td-achip" type="button" data-drop="size">'
      + '<em>Size</em>' + (w || "—") + "/" + (p || "—") + "R" + (r || "—") + "<s>&times;</s></button>");
    FACETS.forEach(function (f) {
      self.state[f.key].forEach(function (v) {
        chips.push('<button class="td-achip" type="button" data-drop="' + f.key + '" data-v="'
          + String(v).replace(/"/g, "&quot;") + '"><em>' + f.label + '</em>'
          + (f.key === "band" ? BANDLABEL[v] : v) + '<s>&times;</s></button>');
      });
    });
    if (this.stock) chips.push('<button class="td-achip" type="button" data-drop="stock">'
      + '<em>Availability</em>In stock<s>&times;</s></button>');
    this.active.innerHTML = chips.length
      ? '<span class="td-achip__lbl">Filtering by</span>' + chips.join("") : "";
    this.active.hidden = chips.length === 0;
  };

  TDCollection.prototype.applySort = function () {
    /* `self` is read inside the comparators, so it has to exist BEFORE the
       sort runs — declaring it underneath left it undefined and threw on
       every sort, silently, because an exception in a listener never reaches
       the code that dispatched the event. */
    var self = this;
    function num(el) { return self.data[el.dataset.i | 0].only || 0; }
    function oi(el) { return self.data[el.dataset.i | 0].oi ? 1 : 0; }
    var how = this.sort, order = this.matched.slice();
    /* Ordered-in always sinks, whichever sort is chosen. Price low to high
       across both would have put a tyre we do not hold above one we do, which
       is the one thing this grid must never do. */
    if (how === "low")       order.sort(function (a, b) { return oi(a) - oi(b) || num(a) - num(b); });
    else if (how === "high") order.sort(function (a, b) { return oi(a) - oi(b) || num(b) - num(a); });
    else order.sort(function (a, b) { return oi(a) - oi(b) || a.dataset.i - b.dataset.i; });
    this.matched = order;
    var frag = document.createDocumentFragment();
    order.forEach(function (c) { frag.appendChild(c); });
    this.grid.appendChild(frag);
  };

  TDCollection.prototype.syncSizer = function () {
    var self = this;
    [["width", "Width"], ["prof", "Profile"], ["rim", "Rim"]].forEach(function (s) {
      var sel = self.sizer.querySelector('[data-sz="' + s[0] + '"]');
      if (!sel) return;
      var chosen = self.size[s[0]];
      var opts = '<option value="">' + s[1] + "</option>";
      self.values(s[0]).forEach(function (v) {
        var n = 0;
        self.data.forEach(function (p) { if (p[s[0]] === v && self.hit(p, "size:" + s[0])) n++; });
        if (n === 0 && v !== chosen) return;      // nothing there, do not offer it
        opts += '<option value="' + v + '"' + (v === chosen ? " selected" : "") + ">"
              + v + (s[0] === "rim" ? "″" : "") + " (" + n + ")</option>";
      });
      sel.innerHTML = opts;
    });
    var read = this.sizer.querySelector("[data-sz-read]");
    if (read) {
      var seg = function (v, dash) { return v ? v : "<u>" + dash + "</u>"; };
      read.innerHTML = seg(this.size.width, "———") + "<s>/</s>"
                     + seg(this.size.prof, "——") + "<s>R</s>"
                     + seg(this.size.rim, "——");
    }
  };

  function boot() {
    [].forEach.call(document.querySelectorAll("[data-td-collection]"), function (root) {
      if (root.__tdBooted) return;
      root.__tdBooted = true;
      new TDCollection(root);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  /* the theme re-renders sections in the customiser */
  document.addEventListener("shopify:section:load", boot);

  window.TDCollection = TDCollection;
})();
